import { render } from "./AIGeneratedQCMQuestion.vue?vue&type=template&id=2e6a7fc0&scoped=true"
import script from "./AIGeneratedQCMQuestion.vue?vue&type=script&lang=js"
export * from "./AIGeneratedQCMQuestion.vue?vue&type=script&lang=js"

import "./AIGeneratedQCMQuestion.vue?vue&type=style&index=0&id=2e6a7fc0&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e6a7fc0"]])

export default __exports__